import { CompareFn } from 'antd/lib/table/interface';
import { renderSortableTitle, sorterWithCompletedOnTop } from './sortingHelpers';
import { FormProcessType } from 'types';
import { getTitleByType } from 'utils/aggregatedPageTypeHelper';
import { CLIENT, TEAM_ADMIN, TEAM_OWNER } from 'settings/constants/roles';
import { ClientColumn, renderLastActivity, renderStatus, TransactionColumn } from './FormsTable';
import classNames from 'classnames';

import styles from './styles.module.scss';
import { Icons } from '../../Icons';

import { NamesContainer } from 'pages/Workshop/Transactions/components/NamesContainer';
import { Avatar } from 'components';
import { Checkbox } from 'components-antd';

export const StatusColumn = ({ row: { status } }) => {
  return renderStatus(status);
};

export const LastActivityColumn = ({ row, justSignedFormProcessPublicId }) => {
  return renderLastActivity(row, justSignedFormProcessPublicId);
};

export const FormColumn = ({ row }) => {
  const formName = row?.formName;

  return (
    <div className={classNames(styles.row, styles.name)}>
      <div className={styles.formAvatarIcon}>
        <Icons variant="file" />
      </div>
      <div className={styles.flexCol}>
        <span className={styles.formName}>{formName}</span>
      </div>
    </div>
  );
};

export const OwnerColumn = ({ row }) => {
  const ownerName = `${row?.creator?.FirstName} ${row?.creator?.LastName}`;
  return (
    <div className={styles.ownerWrapper}>
      {ownerName && row?.creator ? (
        <>
          <Avatar placeholder={row?.creator?.AvatarUrl} avatarClassName={styles.avatarCustom} />
          <div>
            <NamesContainer names={[ownerName]} maxDisplayCount={1} />
          </div>
        </>
      ) : (
        '-'
      )}
    </div>
  );
};
export const formsTableColumns = (columnProps) => {
  const {
    teamRole,
    aggregatedPageType,
    justSignedFormProcessPublicId,
    showSelection,
    setEditId,
    editId,
    refetchForms,
    selectedFormIds,
    handleSelectForm,
  } = columnProps;

  const showOwnerColumn = teamRole === TEAM_OWNER || teamRole === TEAM_ADMIN;
  const isClient = teamRole === CLIENT;

  return [
    {
      title: renderSortableTitle('formName', 'Form', true),
      dataIndex: 'formName',
      key: 'formName',
      width: 300,
      render: (text, row) => <FormColumn row={row} />,
      sorter: sorterWithCompletedOnTop('formName') as CompareFn<FormProcessType>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 150,
      render: (text, row) => <StatusColumn row={row} />,
    },
    {
      title: renderSortableTitle('address', getTitleByType(aggregatedPageType), true),
      dataIndex: 'address',
      key: 'address',
      width: 250,
      render: (text, row) => (
        <TransactionColumn
          row={row}
          setEditId={(value) => setEditId(value)}
          editId={editId}
          refetchForms={refetchForms}
        />
      ),
      sorter: sorterWithCompletedOnTop('address') as CompareFn<FormProcessType>,
    },
    ...(!isClient
      ? [
          {
            title: renderSortableTitle('client', 'Client', true),
            dataIndex: 'client',
            key: 'client',
            width: 250,
            render: (text, row) => (
              <ClientColumn
                row={row}
                setEditId={(value) => setEditId(value)}
                editId={editId}
                refetchForms={refetchForms}
              />
            ),
            sorter: sorterWithCompletedOnTop('client') as CompareFn<FormProcessType>,
          },
        ]
      : []),

    ...(showOwnerColumn
      ? [
          {
            title: 'Owner',
            dataIndex: 'creator',
            key: 'creator',
            width: 250,
            render: (text, row) => <OwnerColumn row={row} />,
          },
        ]
      : []),
    {
      title: 'Last Activity',
      dataIndex: 'status',
      key: 'lastActivity',
      width: 300,
      render: (text, row) => (
        <LastActivityColumn
          row={row}
          justSignedFormProcessPublicId={justSignedFormProcessPublicId}
        />
      ),
    },

    ...(showSelection
      ? [
          {
            title: '',
            key: 'checkbox',
            width: 1,
            render: (_, { formProcessId, isOwner, formName }) => {
              return isOwner ? (
                <div className={styles.multiSelectionCheckbox}>
                  <Checkbox
                    className={styles.checkbox}
                    checked={selectedFormIds?.includes(formProcessId)}
                    onClick={(e: any) => {
                      e.stopPropagation();
                      handleSelectForm(formProcessId, formName, e.target.checked);
                    }}
                  />
                </div>
              ) : (
                ''
              );
            },
          },
        ]
      : []),
  ];
};
